var map = {
	"./back.svg": 5674,
	"./check-circle-filled.svg": 9643,
	"./check.svg": 8739,
	"./close-circle.svg": 3608,
	"./close.svg": 5404,
	"./double-back.svg": 487,
	"./down.svg": 1596,
	"./edit.svg": 1473,
	"./error-circle-filled.svg": 8577,
	"./home.svg": 3165,
	"./info-circle-filled.svg": 200,
	"./left.svg": 5230,
	"./loading.svg": 7456,
	"./phone.svg": 8761,
	"./right.svg": 4449,
	"./search.svg": 6871,
	"./switch.svg": 5201,
	"./top.svg": 126,
	"./user.svg": 6607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2826;